import React from 'react';

class Spinner extends React.Component {
    render() {
        const { isRunning } = this.props;
        return (
            <div className="alert alert-info bg-gray" style={{ display: isRunning ? "" : 'none' }}>
                <i className="fa fa-spinner fa-spin fa-lg mr-10"> </i>  Please wait...
            </div>
        )
    }
}

export default Spinner


// WEBPACK FOOTER //
// ./src/components/shared/spinner.js